var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError, resolveQueryFieldsTransformationPaths, } from '@wix/metro-runtime/velo';
import * as ambassadorWixBookingsStaffV1StaffMember from '@wix/ambassador-bookings-staff-v1-staff-member/http';
// @ts-ignore
import { wrapWithQueryBuilder } from '@wix/motion-edm-autogen-query-wrapper';
let __verbose = false;
function __log(...args) {
    __verbose && console.log(...args);
}
function __inspect(obj) {
    return obj;
}
export const __debug = {
    verboseLogging: {
        on: () => (__verbose = true),
        off: () => (__verbose = false),
    },
};
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var IdentityType;
(function (IdentityType) {
    IdentityType["UNKNOWN"] = "UNKNOWN";
    IdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    IdentityType["MEMBER"] = "MEMBER";
    IdentityType["WIX_USER"] = "WIX_USER";
    IdentityType["APP"] = "APP";
})(IdentityType || (IdentityType = {}));
export var AssociatedWixIdentityConnectionStatusEnumConnectionStatus;
(function (AssociatedWixIdentityConnectionStatusEnumConnectionStatus) {
    /** User connection status is unknown. Only returned when conditional field for status is not selected. */
    AssociatedWixIdentityConnectionStatusEnumConnectionStatus["UNKNOWN"] = "UNKNOWN";
    /** User is connected to the staff member. */
    AssociatedWixIdentityConnectionStatusEnumConnectionStatus["CONNECTED"] = "CONNECTED";
    /** User connection is pending. */
    AssociatedWixIdentityConnectionStatusEnumConnectionStatus["PENDING"] = "PENDING";
    /** Pending connections invite has expired. */
    AssociatedWixIdentityConnectionStatusEnumConnectionStatus["EXPIRED"] = "EXPIRED";
    /** User is disconnected from the staff member. */
    AssociatedWixIdentityConnectionStatusEnumConnectionStatus["DISCONNECTED"] = "DISCONNECTED";
})(AssociatedWixIdentityConnectionStatusEnumConnectionStatus || (AssociatedWixIdentityConnectionStatusEnumConnectionStatus = {}));
export var ConnectionStatus;
(function (ConnectionStatus) {
    ConnectionStatus["UNKNOWN"] = "UNKNOWN";
    /** Provider is connected to site and user is authenticated. */
    ConnectionStatus["CONNECTED"] = "CONNECTED";
    /** Provider is not connected to site or user is not authenticated. */
    ConnectionStatus["DISCONNECTED"] = "DISCONNECTED";
})(ConnectionStatus || (ConnectionStatus = {}));
export var RequestedFields;
(function (RequestedFields) {
    RequestedFields["UNKNOWN_REQUESTED_FIELD"] = "UNKNOWN_REQUESTED_FIELD";
    /** Fields inside `resource` */
    RequestedFields["RESOURCE_DETAILS"] = "RESOURCE_DETAILS";
    /** Fields inside `associatedConferencingProviders` */
    RequestedFields["ASSOCIATED_CONFERENCING_PROVIDERS"] = "ASSOCIATED_CONFERENCING_PROVIDERS";
    /** `associatedWixIdentity.connectionStatus` */
    RequestedFields["ASSOCIATED_IDENTITY_STATUS"] = "ASSOCIATED_IDENTITY_STATUS";
})(RequestedFields || (RequestedFields = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var Day;
(function (Day) {
    /** Undefined. */
    Day["UNDEFINED"] = "UNDEFINED";
    /** Monday. */
    Day["MON"] = "MON";
    /** Tuesday. */
    Day["TUE"] = "TUE";
    /** Wednesday. */
    Day["WED"] = "WED";
    /** Thursday. */
    Day["THU"] = "THU";
    /** Friday. */
    Day["FRI"] = "FRI";
    /** Saturday. */
    Day["SAT"] = "SAT";
    /** Sunday. */
    Day["SUN"] = "SUN";
})(Day || (Day = {}));
export var Transparency;
(function (Transparency) {
    Transparency["UNDEFINED"] = "UNDEFINED";
    /** The schedule can have available slots during the session. */
    Transparency["FREE"] = "FREE";
    /** The schedule cannot have available slots during the session. Default value. */
    Transparency["BUSY"] = "BUSY";
})(Transparency || (Transparency = {}));
export var RecurringIntervalType;
(function (RecurringIntervalType) {
    /** The default value. Sessions for this interval will be of type EVENT. */
    RecurringIntervalType["UNDEFINED"] = "UNDEFINED";
    /** A recurring interval of events */
    RecurringIntervalType["EVENT"] = "EVENT";
    /** Deprecated */
    RecurringIntervalType["TIME_AVAILABILITY"] = "TIME_AVAILABILITY";
    /** A recurring interval for availability */
    RecurringIntervalType["AVAILABILITY"] = "AVAILABILITY";
})(RecurringIntervalType || (RecurringIntervalType = {}));
export var LocationType;
(function (LocationType) {
    LocationType["UNDEFINED"] = "UNDEFINED";
    LocationType["OWNER_BUSINESS"] = "OWNER_BUSINESS";
    LocationType["OWNER_CUSTOM"] = "OWNER_CUSTOM";
    LocationType["CUSTOM"] = "CUSTOM";
})(LocationType || (LocationType = {}));
/** For future use */
export var LocationStatus;
(function (LocationStatus) {
    LocationStatus["ACTIVE"] = "ACTIVE";
    LocationStatus["INACTIVE"] = "INACTIVE";
})(LocationStatus || (LocationStatus = {}));
/** For future use */
export var LocationsLocationType;
(function (LocationsLocationType) {
    LocationsLocationType["UNKNOWN"] = "UNKNOWN";
    LocationsLocationType["BRANCH"] = "BRANCH";
    LocationsLocationType["OFFICES"] = "OFFICES";
    LocationsLocationType["RECEPTION"] = "RECEPTION";
    LocationsLocationType["HEADQUARTERS"] = "HEADQUARTERS";
    LocationsLocationType["INVENTORY"] = "INVENTORY";
})(LocationsLocationType || (LocationsLocationType = {}));
/** Enumerates the days of the week. */
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["MONDAY"] = "MONDAY";
    DayOfWeek["TUESDAY"] = "TUESDAY";
    DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    DayOfWeek["THURSDAY"] = "THURSDAY";
    DayOfWeek["FRIDAY"] = "FRIDAY";
    DayOfWeek["SATURDAY"] = "SATURDAY";
    DayOfWeek["SUNDAY"] = "SUNDAY";
})(DayOfWeek || (DayOfWeek = {}));
export var ApprovalStatus;
(function (ApprovalStatus) {
    /** Default. */
    ApprovalStatus["UNDEFINED"] = "UNDEFINED";
    /** Pending business approval. */
    ApprovalStatus["PENDING"] = "PENDING";
    /** Approved by the business. */
    ApprovalStatus["APPROVED"] = "APPROVED";
    /** Declined by the business. */
    ApprovalStatus["DECLINED"] = "DECLINED";
})(ApprovalStatus || (ApprovalStatus = {}));
export var ScheduleStatus;
(function (ScheduleStatus) {
    ScheduleStatus["UNDEFINED"] = "UNDEFINED";
    /** The default value when the schedule is created. */
    ScheduleStatus["CREATED"] = "CREATED";
    /** The schedule has been canceled. */
    ScheduleStatus["CANCELLED"] = "CANCELLED";
})(ScheduleStatus || (ScheduleStatus = {}));
export var ConferenceType;
(function (ConferenceType) {
    ConferenceType["UNDEFINED"] = "UNDEFINED";
    /** API-generated online meeting. */
    ConferenceType["ONLINE_MEETING_PROVIDER"] = "ONLINE_MEETING_PROVIDER";
    /** User-defined meeting. */
    ConferenceType["CUSTOM"] = "CUSTOM";
})(ConferenceType || (ConferenceType = {}));
export var CalendarType;
(function (CalendarType) {
    CalendarType["UNDEFINED"] = "UNDEFINED";
    CalendarType["GOOGLE"] = "GOOGLE";
    CalendarType["I_CAL"] = "I_CAL";
    /** Use `MICROSOFT` instead. */
    CalendarType["OUTLOOK"] = "OUTLOOK";
    /** Use `MICROSOFT` instead. */
    CalendarType["OFFICE_365"] = "OFFICE_365";
    CalendarType["MICROSOFT"] = "MICROSOFT";
    CalendarType["OTHER"] = "OTHER";
})(CalendarType || (CalendarType = {}));
export var Status;
(function (Status) {
    Status["UNDEFINED"] = "UNDEFINED";
    /** The session is confirmed. Default status. */
    Status["CONFIRMED"] = "CONFIRMED";
    /**
     * The session is cancelled.
     * A cancelled session can be the cancellation of a recurring session that should no longer be displayed or a deleted single session.
     * The ListSessions returns cancelled sessions only if 'includeDelete' flag is set to true.
     */
    Status["CANCELLED"] = "CANCELLED";
})(Status || (Status = {}));
export var SessionType;
(function (SessionType) {
    SessionType["UNDEFINED"] = "UNDEFINED";
    /**
     * The session creates an event on the calendar for the owner of the schedule that the session belongs to.
     * Default type.
     */
    SessionType["EVENT"] = "EVENT";
    /** The session represents a resource's available working hours. */
    SessionType["WORKING_HOURS"] = "WORKING_HOURS";
    /** Deprecated. please use WORKING_HOURS */
    SessionType["TIME_AVAILABILITY"] = "TIME_AVAILABILITY";
    /** Deprecated. The session represents a resource's available hours. please use WORKING_HOURS */
    SessionType["AVAILABILITY"] = "AVAILABILITY";
})(SessionType || (SessionType = {}));
const _assignBusinessScheduleRequest = {};
const _assignBusinessScheduleResponse = { staffMember: '_staffMember' };
const _assignCustomScheduleRequest = {};
const _assignCustomScheduleResponse = { staffMember: '_staffMember' };
const _connectToUserRequest = {};
const _connectToUserResponse = { staffMember: '_staffMember' };
const _countStaffMembersRequest = {};
const _countStaffMembersResponse = {};
const _createStaffMemberRequest = { staffMember: '_staffMember' };
const _createStaffMemberResponse = { staffMember: '_staffMember' };
const _deleteStaffMemberRequest = {};
const _deleteStaffMemberResponse = {};
const _disconnectUserRequest = {};
const _disconnectUserResponse = { staffMember: '_staffMember' };
const _getStaffMemberRequest = {};
const _getStaffMemberResponse = { staffMember: '_staffMember' };
const _mediaItem = { image: 'wix.common.Image' };
const _queryStaffMembersRequest = {};
const _queryStaffMembersResponse = { staffMembers: '_staffMember' };
const _staffMember = { mainMedia: '_mediaItem' };
const _updateStaffMemberRequest = { staffMember: '_staffMember' };
const _updateStaffMemberResponse = { staffMember: '_staffMember' };
/**
 * Creates a StaffMember.
 * @param staffMember - StaffMember to be created.
 * @internal
 * @documentationMaturity preview
 * @requiredField staffMember
 * @requiredField staffMember.name
 * @adminMethod
 * @returns The created StaffMember.
 */
export function createStaffMember(staffMember, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { staffMember: '$[0]', fields: '$[1].fields' };
        const responseTransformation = '$.staffMember';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createStaffMemberRequest,
            depSchemas: { _mediaItem, _staffMember },
            fqdnTransformation: {
                paths: [...['staffMember']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createStaffMemberResponse,
            depSchemas: { _mediaItem, _staffMember },
            fqdnTransformation: {
                paths: [...['staffMember']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([staffMember, options]);
        const reqOpts = ambassadorWixBookingsStaffV1StaffMember.createStaffMember(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        __log(`"CreateStaffMember" sending request with: ${__inspect(reqOptionWithHeadersWrapper)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'staffMember',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a StaffMember by id.
 * @param staffMemberId - ID of the StaffMember to retrieve.
 * @internal
 * @documentationMaturity preview
 * @requiredField staffMemberId
 * @adminMethod
 * @returns The requested StaffMember.
 */
export function getStaffMember(staffMemberId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            staffMemberId: '$[0]',
            fields: '$[1].fields',
        };
        const responseTransformation = '$.staffMember';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getStaffMemberRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getStaffMemberResponse,
            depSchemas: { _mediaItem, _staffMember },
            fqdnTransformation: {
                paths: [...['staffMember']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([staffMemberId, options]);
        const reqOpts = ambassadorWixBookingsStaffV1StaffMember.getStaffMember(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        __log(`"GetStaffMember" sending request with: ${__inspect(reqOptionWithHeadersWrapper)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'staffMemberId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Update a StaffMember, supports partial update
 * Pass the latest `revision` for a successful update
 * @param _id - StaffMember ID
 * @internal
 * @documentationMaturity preview
 * @requiredField _id
 * @requiredField staffMember
 * @requiredField staffMember.revision
 * @adminMethod
 * @returns Updated StaffMember.
 */
export function updateStaffMember(_id, staffMember, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            staffMember: { '*': '$[1]', id: '$[0]' },
            fieldMask: '$[2].fieldMask',
            fields: '$[2].fields',
        };
        const responseTransformation = '$.staffMember';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateStaffMemberRequest,
            depSchemas: { _mediaItem, _staffMember },
            fqdnTransformation: {
                paths: [...['staffMember']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateStaffMemberResponse,
            depSchemas: { _mediaItem, _staffMember },
            fqdnTransformation: {
                paths: [...['staffMember']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, staffMember, options]);
        const reqOpts = ambassadorWixBookingsStaffV1StaffMember.updateStaffMember(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        __log(`"UpdateStaffMember" sending request with: ${__inspect(reqOptionWithHeadersWrapper)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'staffMember',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Deletes a StaffMember.
 * @param staffMemberId - Id of the StaffMember to delete.
 * @internal
 * @documentationMaturity preview
 * @requiredField staffMemberId
 * @adminMethod
 */
export function deleteStaffMember(staffMemberId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { staffMemberId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _deleteStaffMemberRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _deleteStaffMemberResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([staffMemberId]);
        const reqOpts = ambassadorWixBookingsStaffV1StaffMember.deleteStaffMember(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        __log(`"DeleteStaffMember" sending request with: ${__inspect(reqOptionWithHeadersWrapper)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'staffMemberId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Query StaffMembers using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language)
 * @internal
 * @documentationMaturity preview
 * @adminMethod
 */
export function queryStaffMembers(options) {
    const requestTransformation = { '*': '$[1]', query: '$[0]' };
    const responseTransformation = {
        items: '$.staffMembers',
        pagingMetadata: '$.metadata',
    };
    // @ts-ignore
    const { httpClient, sideEffects, additionalHeaders } = arguments[1];
    const { toAmbassadorRequest } = serializer({
        rootSchema: _queryStaffMembersRequest,
        depSchemas: {},
        fqdnTransformation: {
            paths: [],
            transformation: _fromVeloEntity,
        },
        customTransformation: requestTransformation,
    });
    const { fromJSON } = serializer({
        rootSchema: _queryStaffMembersResponse,
        depSchemas: { _mediaItem, _staffMember },
        fqdnTransformation: {
            paths: [...['Array#staffMembers']],
            transformation: _toVeloEntity,
        },
        customTransformation: responseTransformation,
    });
    return wrapWithQueryBuilder({
        func: (payload) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const reqOpts = ambassadorWixBookingsStaffV1StaffMember.queryStaffMembers(Object.assign(Object.assign({}, payload), (options !== null && options !== void 0 ? options : {})));
            const reqOptionWithHeadersWrapper = (args) => {
                const result = reqOpts(args);
                if (additionalHeaders) {
                    const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                    return Object.assign(Object.assign({}, result), { headers });
                }
                return result;
            };
            (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
            try {
                const result = yield httpClient.request(reqOptionWithHeadersWrapper);
                (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
                return result;
            }
            catch (err) {
                (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
                throw err;
            }
        }),
        requestTransformer: (...args) => toAmbassadorRequest(args),
        responseTransformer: ({ data }) => fromJSON(data),
        errorTransformer: (err) => {
            const transformedError = transformError(err, requestTransformation);
            throw transformedError;
        },
        pagingMethod: 'CURSOR',
        transformationPaths: resolveQueryFieldsTransformationPaths(_toVeloEntity),
    })({ cursorWithEmptyFilterAndSort: true });
}
/**
 * Counts staff members according to given criteria.
 * @internal
 * @documentationMaturity preview
 * @adminMethod
 */
export function countStaffMembers(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { filter: '$[0].filter' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _countStaffMembersRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _countStaffMembersResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixBookingsStaffV1StaffMember.countStaffMembers(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        __log(`"CountStaffMembers" sending request with: ${__inspect(reqOptionWithHeadersWrapper)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Assigns the provided schedule to the StaffMember
 * @param staffMemberId - Id of the StaffMember to assign to.
 * @param scheduleId - Id of a schedule to assign.
 * @internal
 * @documentationMaturity preview
 * @requiredField scheduleId
 * @requiredField staffMemberId
 * @adminMethod
 */
export function assignCustomSchedule(staffMemberId, scheduleId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            staffMemberId: '$[0]',
            scheduleId: '$[1]',
            fields: '$[2].fields',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _assignCustomScheduleRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _assignCustomScheduleResponse,
            depSchemas: { _mediaItem, _staffMember },
            fqdnTransformation: {
                paths: [...['staffMember']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([staffMemberId, scheduleId, options]);
        const reqOpts = ambassadorWixBookingsStaffV1StaffMember.assignCustomSchedule(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        __log(`"AssignCustomSchedule" sending request with: ${__inspect(reqOptionWithHeadersWrapper)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'staffMemberId',
                'scheduleId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Assigns the business schedule to the StaffMember
 * @param staffMemberId - Id of the StaffMember to assign to.
 * @internal
 * @documentationMaturity preview
 * @requiredField staffMemberId
 * @adminMethod
 */
export function assignBusinessSchedule(staffMemberId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            staffMemberId: '$[0]',
            fields: '$[1].fields',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _assignBusinessScheduleRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _assignBusinessScheduleResponse,
            depSchemas: { _mediaItem, _staffMember },
            fqdnTransformation: {
                paths: [...['staffMember']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([staffMemberId, options]);
        const reqOpts = ambassadorWixBookingsStaffV1StaffMember.assignBusinessSchedule(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        __log(`"AssignBusinessSchedule" sending request with: ${__inspect(reqOptionWithHeadersWrapper)}`);
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'staffMemberId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=bookings-staff-v1-staff-member.universal.js.map